import React from 'react';
import {BaseModal} from '../../comun/Index';

class Nueva extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      documento:"",
      nombre:"",
      user:"",
      mail:"",
      tipo:1,
      localidad_id:"",
      area_id:-1,
      telefono:""
    }
  }
  componentDidMount(){
    if (this.props.datos !== undefined){
      this.setState(JSON.parse(JSON.stringify(this.props.datos)));
    }
    this.setState({localidad_id:this.props.localidades[0].id})
  }

  render(){
    const {documento, nombre, user, mail, tipo, localidad_id, area_id, telefono} = this.state;
    const {localidades, areas} = this.props;
    return(
      <BaseModal
        titulo="Datos de Usuario"
        loading={false}
        botonera={[
          {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => this.props.salir()},
          {titulo:"Guardar", backgroundColor:'#00B845', onClick: () => this.props.guardar(this.state)}
        ]}
      >
        <div className="Seccion" style={{width:'90%'}}>
          <input
            type="text" style={{flex:1, textAlign:'center'}}
            onChange={(e)=>this.setState({documento:e.target.value})}
            value={documento}
            placeholder="Documento"
          />
          <input
            type="text" style={{flex:1, textAlign:'center'}}
            onChange={(e)=>this.setState({nombre:e.target.value})}
            value={nombre}
            placeholder="Nombre completo"
          />
        </div>
        <div className="Seccion" style={{width:'90%'}}>
          <input
            type="text" style={{flex:1, textAlign:'center'}}
            onChange={(e)=>this.setState({user:e.target.value})}
            value={user}
            placeholder="Usuario"
          />
          <select
            onChange={(e)=>this.setState({localidad_id:e.target.value})}
            value={localidad_id}
            style={{marginLeft:5, flex:1}}
          >
            {localidades.map((item, index) => {
              return(
                <option value={item.id} key={index}>{item.descripcion}</option>
              )
            })}
          </select>
        </div>
        <div className="Seccion" style={{width:'90%'}}>
          <select
            onChange={(e)=>this.setState({tipo:e.target.value, area_id:0})}
            value={tipo}
            style={{marginRight:5, flex:1}}
          >
            <option value={1}>Mesa de entrada</option>
            <option value={2}>Agente</option>
            <option value={3}>Autoridad</option>
            <option value={4}>Administrador</option>
          </select>
          <select
            onChange={(e)=>this.setState({area_id:e.target.value})}
            value={area_id}
            style={{marginLeft:5, flex:1}}
          >
            <option value="-1">Área</option>
            {areas.map((item, index) => {
              return(
                <option value={item.id} key={index}>{item.nombre}</option>
              )
            })}
          </select>
        </div>
        <div className="Seccion" style={{width:'90%'}}>
          <input
            type="tel" style={{flex:1, textAlign:'center'}}
            onChange={(e)=>this.setState({telefono:e.target.value})}
            value={telefono}
            placeholder="Telefono"
          />
            <input
              type="email" style={{flex:1, textAlign:'center'}}
              onChange={(e)=>this.setState({mail:e.target.value})}
              value={mail}
              placeholder="eMail"
            />
        </div>
      </BaseModal>
    );
  }
}

export default Nueva;
